<!-- 车辆服务-系统订单详情 -->

<template>
  <div class="car-order-info-dialog">
    <el-dialog v-model="dialogVisible" top="5vh" title="订单详情" width="60%" center>
      <div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="flex align-center">
              <div class="order-top-title">支付状态</div>
              <div class="status-text" :class="statusCustom(detailInfo.order.or_pay_status, 'pay')">
                {{ detailInfo.order.or_pay_status_text }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex align-center">
              <div class="order-top-title">订单状态</div>
              <div class="status-text" :class="statusCustom(detailInfo.orderCarmeet.oc_status, 'order')">
                {{ detailInfo.orderCarmeet.oc_status_text }}</div>
            </div>
          </el-col>
        </el-row>

        <div class="route-infor">
          <div class="route-infor-title">{{ detailInfo.carmeet.oc_mcr_name }}</div>
          <el-row :gutter="20">
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">运营时段</div>
                <div class="order-top-content">{{ detailInfo.carmeet.oc_run_time }}</div>
              </div>
            </el-col>
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">咨询电话</div>
                <div class="order-top-content">{{ detailInfo.carmeet.oc_mcr_tel }}</div>
              </div>
            </el-col>
            <el-col :span="24" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">路线描述</div>
                <textarea v-model="detailInfo.carmeet.oc_mcr_route_desc" class="order-rule-text" readonly
                  :rows="1"></textarea>
              </div>
            </el-col>
            <el-col :span="24" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">规则说明</div>
                <textarea v-model="detailInfo.carmeet.oc_mcr_rule_desc" class="order-rule-text" readonly
                  :rows="1"></textarea>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="route-infor">
          <div class="route-infor-title">{{ detailInfo.orderCarmeet.oc_subscribe_type_text }}</div>
          <el-row :gutter="20">
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">{{ detailInfo.orderCarmeet.oc_subscribe_type == '1' ? '乘车人' : '包车数量' }}
                </div>
                <div class="order-top-content">{{ detailInfo.orderCarmeet.oc_number }}{{
                  detailInfo.orderCarmeet.oc_subscribe_type ==
                    '1' ? '人' : '车' }}
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">联系人</div>
                <div class="order-top-content">{{ detailInfo.orderCarmeet.oc_contact_people }}</div>
              </div>
            </el-col>
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">联系电话</div>
                <div class="order-top-content">{{ detailInfo.orderCarmeet.oc_contact_tel }}</div>
              </div>
            </el-col>
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">用车时间</div>
                <div class="order-top-content">
                  <div>
                    {{ detailInfo.orderCarmeet.oc_subscribe_time }}
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">备注说明</div>
                <div class="order-top-content">{{ detailInfo.orderCarmeet.oc_desc }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="route-infor">
          <div class="route-infor-title">订单信息</div>
          <el-row :gutter="20">
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">订单金额</div>
                <div class="order-top-content">{{ detailInfo.order.or_allmoney }}</div>
              </div>
            </el-col>
            <el-col :span="12" class="s-m-b">
              <div class="flex">
                <div class="order-top-title">支付时间</div>
                <div class="order-top-content">{{ detailInfo.order.or_pay_time }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <template #footer>
        <!-- 已支付待接单 -->
        <div v-if="detailInfo.order.or_pay_status == '2' && detailInfo.orderCarmeet.oc_status == '1'">
          <el-button @click="onClickBtn('refuse')" type="primary" class="cancle" plain round :loading="isLoading"
            style="width:120px" v-if="authData.indexOf('n_d23ced39ba48a02193a18fce3') != -1">拒接
          </el-button>
          <el-button class="confirm" @click="onClickBtn('infoAccept')" round :loading="isLoading" :disabled="isLoading"
            style="width:120px">接单
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, watch, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";

export default {
  emits: ["submit"],
  setup(props, { emit }) {
    const store = useStore();
    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    const dialogVisible = ref(false);
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const detailInfo = ref({
      order: {},  // 订单信息
      carmeet: {},  // 车辆服务信息
      orderCarmeet: {},  // 订单车辆服务信息
    });  // 详情数据
    const isLoading = ref(false);
    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      getOrderInfo(row);
      dialogVisible.value = true;
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogVisible.value = false;
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      isLoading.value = false;
    }
    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getOrderInfo = (row) => {
      currentRow.value = row;
      VipApi.getCarOrderDetail({ order_sn: row.or_sn, }).then(res => {
        if (res.Code == 200) {
          detailInfo.value = res.Data;
        } else {
          ElMessage.error(res.Message);
        }
      })
    }
    /**
    * 
    * 点击操作按钮
    * 
    * **/
    const onClickBtn = (type) => {
      let data = {
        ...currentRow.value,
        ...detailInfo.value.orderCarmeet,
      };
      emit("submit", data, type);
    }
    /**
    * 
    * 状态
    * 
    * **/
    const statusCustom = (status, type) => {
      let payment_color = '';  // 支付状态 1-待交 2-已支付 3-订单取消 5-已退款
      let status_color = '';  // 订单状态 1=待接单，2=已接单，3=已完成，8=已取消，9=未接单
      switch (status) {
        case 1:
          payment_color = 'btn-red';
          status_color = 'btn-orange';
          break;
        case 2:
          payment_color = 'btn-green';
          status_color = 'btn-yellow';
          break;
        case 3:
          payment_color = 'btn-grey';
          status_color = 'btn-blue';
          break;
        case 5:
          payment_color = 'btn-black';
          break;
        case 8:
          status_color = 'btn-black';
          break;
        case 9:
          status_color = 'btn-grey';
          break;
      }
      if (type == 'pay') {
        return payment_color;
      } else {
        return status_color;
      }
    }

    return {
      store,
      menuTokens,
      authData,
      dialogVisible,
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      detailInfo,
      getOrderInfo,
      statusCustom,
      isLoading,
      onClickBtn,
    };
  },
};
</script>

<style lang="scss">
.car-order-info-dialog {
  .xs-m-b {
    margin-bottom: 5px;
  }

  .s-m-b {
    margin-bottom: 10px;
  }

  .cancle {
    border: 2px solid var(--theme-color);
    padding: 10px 45px;
    color: var(--theme-color);
    background-color: #ffffff;
  }

  .order-top-title {
    color: #92979E;
    width: 80px;
    text-align: left;
    // margin-bottom: 10px;
    flex-shrink: 0;
  }

  .route-infor {
    background-color: #F8F9FA;
    border-radius: 8px;
    padding: 15px;
    margin-top: 20px;
  }

  .route-infor-title {
    color: #262C30;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .order-top-content {
    color: #262C30;
  }

  .order-rule-text {
    border: none;
    font-family: Source Han Sans CN;
    font-size: 14px;
    width: 100% !important;
    background-color: #F8F9FA;
  }

  .complete-btn {
    background-color: var(--theme-color) !important;
    color: var(--text-white-color) !important;
    border: 1px solid var(--theme-color) !important;
    width: 120px;

    &:hover {
      background-color: var(--theme-color) !important;
      color: var(--text-white-color) !important;
      border: 1px solid var(--theme-color) !important;
    }
  }

  .vehicle-info {
    background-color: var(--theme-color);
    color: var(--text-white-color);
    border-radius: 4px;
    font-size: 12px;
    padding: 0 5px;
    height: 26px;
    line-height: 26px;
    margin: 0 10px 5px 0;
  }
}
</style>